import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Input, Output, OnInit, ViewChild} from "@angular/core";
import {Bot} from "../../../../../../models/bot";
import {FieldGroup} from "../../../../../../models/field-group";
import {FormField} from "../../../../../../models/form-field";
import {MappingBoard} from "../../../../../../models/mapping-board";
import {MuleService} from "../../../../../../models/mule-service";
import {Service} from "../../../../../../models/service";
import {BotControllerService} from "../../../../../../services/role-controller/bot-controller.service";
import {DataMapping} from "../../../../../../models/data-mapping";
import { BaseError } from "../../../../base-error";
import * as cloneDeep from "lodash/cloneDeep";
import {ToastrService} from "ngx-toastr";
import {LogicGroupType} from "../../../../../../models/jsonlogic/logic-group-type";
import { map } from "rxjs/operators";
import { OneToManyQueryComponent } from "./data-transformations/one-to-many-query/one-to-many-query.component";
import Helpers from "../../../../../../utils/helpers";

@Component({
    selector: "mapping-board",
    templateUrl: "./mapping-board.component.html",
})
export class MappingBoardComponent extends BaseError implements OnInit {

    @Input() public serviceId: string;
    @Input() public mappingBoard: MappingBoard;
    @Input() public selectedMuleService: MuleService = null;

    @Input() public showDatabases: any = { value: true };
    @Input() public flexRemoteDatabases: any = { value: true };
    @Input() public muleServices: MuleService[];
    @Input() public allServices: Service[] = [];
    @Input() public allServiceFields: FormField[] = [];
    @Input() public internalAllServiceFields: FormField[] = [];
    @Input() public fieldGroups: FieldGroup[] = [];
    @Input() public internalFieldGroups: FieldGroup[] = [];
    @Input() public bot: Bot;
    @Input() public rightFields: any[];

    @Input() public hideFormFields: any = {};
    @Input() public rootCss: string = "";
    @Input() public checkingVisibility: any = { value: false };

    // just for right side
    @Input() public fields: any[];
    @Input() public hideFields: any;
    @Input() public generateRightEstructure: boolean = false;
    @Input() public checkingNewServiceLinks: boolean = false;

    public allFieldGroups: FieldGroup[] = [];
    public internalAllFieldGroups: FieldGroup[] = [];
    public filteredFieldGroups: FieldGroup[] = [];
    public filteredRightFieldGroups: FormField[] = [];

    public leftTabs: any[] = [];
    public rightTabs: any[] = [];
    public selectedLeftTab: any = null;
    public selectedRightTab: any = null;

    public requestType: string = null;

    public isLastServiceVersion: boolean = true;
    public showEntriesButton: boolean = false;

    public isOTMClosed: boolean = true;

    @Output("handleScroll") public handleScroll: EventEmitter<any> = new EventEmitter();
    @Output("updateHiddenServiceFields") public updateHiddenServiceFields: EventEmitter<any> = new EventEmitter();
    @Output("updateRelationshipsPositions") public updateRelationshipsPositions: EventEmitter<any> = new EventEmitter();
    @Output("updateLinesVisibility") public updateLinesVisibility: EventEmitter<any> = new EventEmitter();
    @Output("setSelectedMuleService") public setSelectedMuleService: EventEmitter<any> = new EventEmitter();
    @Output("saveLines") public saveLines: EventEmitter<any> = new EventEmitter();
    @Output("setBotService") public setBotService: EventEmitter<any> = new EventEmitter();
    @Output("changeBotService") public changeBotService: EventEmitter<any> = new EventEmitter();
    @Output("setBoardVisibility") public setBoardVisibility: EventEmitter<any> = new EventEmitter();
    @Output("itemDrop") public itemDrop: EventEmitter<any> = new EventEmitter();
    @Output("addDataTransformation") public addDataTransformation: EventEmitter<any> = new EventEmitter();
    @Output() public showLines = new EventEmitter();
    @Output() public hideLines = new EventEmitter();
    @Output() public askToOpenEntriesFilters = new EventEmitter();
    @Output() public saveQueryEvent = new EventEmitter();
    @ViewChild(OneToManyQueryComponent) public oneToManyQueryComponent: OneToManyQueryComponent;

    constructor(
        private botController: BotControllerService,
        public toastr: ToastrService,
    ) {
        super(toastr);
    }

    public ngOnInit(): void {
        if (this.bot && this.bot.botServiceId && this.muleServices) {
            this.checkVersion();
        }
        if (this.internalFieldGroups.length) {
            this.internalAllFieldGroups = cloneDeep(this.internalFieldGroups);
        }
        if (this.fieldGroups.length) {
            this.allFieldGroups = cloneDeep(this.fieldGroups);
            this.initTabs();
        }
        this.setRequestType();
        this.filteredRightFieldGroups = cloneDeep(this.internalAllServiceFields);
        this.isEntriesBoard();
        // console.log("--- MB", this.mappingBoard, this.bot, this.fields, this.allServiceFields);
    }

    public saveRequestsBuilder() {
        this.oneToManyQueryComponent.saveSettings();
    }

    public isEntriesBoard() {
        if (this.selectedMuleService?.id?.endsWith("-entries")) {
            return this.showEntriesButton = true;
        } else {
            return this.showEntriesButton = false;
        }
    }

    public openEntriesFilters() {
        this.askToOpenEntriesFilters.emit({type: this.requestType});
    }

    public hasEntriesDeterminants() {
        let hasED = false;
        if (this.requestType === "write" && this.bot.inputFieldsFilter?.length && JSON.stringify(this.bot.inputFieldsFilter) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            hasED = true;
        }
        return hasED;
    }

    public hasGueryDefinitions() {
        let hasED = false;
        if (this.requestType === "query" && this.bot.inputQueryFilter?.length && (JSON.stringify(this.bot.inputQueryFilter) !== "[{\"type\":\"OR\",\"items\":[]}]" && JSON.stringify(this.bot.inputQueryFilter) !== "[{\"type\":\"AND\",\"items\":[]}]" && JSON.stringify(this.bot.inputQueryFilter) !== "")) {
            hasED = true;
        }
        return hasED;
    }

    public formatTabsLeft(): void {
        if (this.mappingBoard) {
            const container = document.getElementById("leftTabsContainer-" + this.mappingBoard.id);
            const tabs = document.getElementById("leftTabsList-" + this.mappingBoard.id);
            const tabsResp = document.getElementById("leftTabsResp-" + this.mappingBoard.id);
            if (tabs) {
            tabs.classList.add("loading");
            tabs.classList.remove("d-none");
            tabs.classList.remove("d-none");
            }
            if (tabsResp) {
            tabsResp.classList.add("loading");
            tabsResp.classList.remove("d-none");
            }
            if (container) {
            container.classList.remove("d-none");
            }
            if (container && tabs && tabsResp) {
                tabs.classList.remove("loading");
                tabsResp.classList.remove("loading");
                if (Number(container.getBoundingClientRect().width) <= (tabs.getBoundingClientRect().width)) {
                    tabsResp.classList.remove("d-none");
                    tabs.classList.add("d-none");
                } else {
                    tabs.classList.remove("d-none");
                    tabsResp.classList.add("d-none");
                }
            }
        }
    }

    public formatTabsRight(): void {
        if (this.mappingBoard && this.bot.botType === "internal") {
            const container = document.getElementById("rightTabsContainer-" + this.mappingBoard.id);
            const tabs = document.getElementById("rightTabsList-" + this.mappingBoard.id);
            const tabsResp = document.getElementById("rightTabsResp-" + this.mappingBoard.id);
            if (tabs) {
            tabs.classList.add("loading");
            tabs.classList.remove("d-none");
            tabs.classList.remove("d-none");
            }
            if (tabsResp) {
            tabsResp.classList.add("loading");
            tabsResp.classList.remove("d-none");
            }
            if (container) {
            container.classList.remove("d-none");
            }
            if (container && tabs && tabsResp) {
                tabs.classList.remove("loading");
                tabsResp.classList.remove("loading");
                if (Number(container.getBoundingClientRect().width) <= (tabs.getBoundingClientRect().width)) {
                    tabsResp.classList.remove("d-none");
                    tabs.classList.add("d-none");
                } else {
                    tabs.classList.remove("d-none");
                    tabsResp.classList.add("d-none");
                }
            }
        }
    }

    public initTabs() {
        this.leftTabs = [];
        this.leftTabs.push({
            name: "All fields",
            active: true,
            filter: null,
        });
        this.rightTabs = [];
        this.rightTabs.push({
            name: "All fields",
            active: true,
            filter: null,
        });
        this.allFieldGroups.forEach((g) => {
            if ((g.groupName === "GUIDEFORM" || g.groupName === "FORM" || g.groupName === "DOCUMENT" || g.groupName === "PAYMENT" || g.groupName === "ROLE" || g.groupName === "CERT" || g.groupName === "RESULT") && (g.items && g.items.length)) {
                this.leftTabs.push({
                    name: g.groupName,
                    active: false,
                    filter: g.groupName,
                });
                g.tab = g.groupName;
            } else {
                g.tab = "other";
            }
        });
        const rightGroups = this.bot.botType === "internal" ? this.internalAllFieldGroups : this.allFieldGroups;
        rightGroups.forEach((g) => {
            if ((g.groupName === "GUIDEFORM" || g.groupName === "FORM" || g.groupName === "DOCUMENT" || g.groupName === "PAYMENT" || g.groupName === "ROLE" || g.groupName === "CERT" || g.groupName === "RESULT") && (g.items && g.items.length)) {
                this.rightTabs.push({
                    name: g.groupName,
                    active: false,
                    filter: g.groupName,
                });
                g.tab = g.groupName;
            } else {
                g.tab = "other";
            }
        });

        this.leftTabs.push({
            name: "Others",
            active: false,
            filter: "other",
        });
        this.rightTabs.push({
            name: "Others",
            active: false,
            filter: "other",
        });

        if (this.bot.botType === "internal") {
            this.fields = cloneDeep(rightGroups);
        }
        this.filteredFieldGroups = this.allFieldGroups;

        setTimeout(() => {
            this.formatTabsLeft();
        }, 1000);
        setTimeout(() => {
            this.formatTabsRight();
        }, 1000);
    }

    public onResize(event) {
        this.formatTabsLeft();
        this.formatTabsRight();
    }

    public setSelectedLeftTab(s: any) {
        this.leftTabs.forEach((g) => {
            g.active = (g === s) ? true : false;
        });
        this.selectedLeftTab = s.filter;
        if (s.filter !== null) {
            this.setLeftTabCollapse(false);
        } else {
            this.setLeftCollapse(true);
        }
    }

    public setSelectedRightTab(s: any) {
        this.rightTabs.forEach((g) => {
            g.active = (g === s) ? true : false;
        });
        this.selectedRightTab = s.filter;
        if (s.filter !== null) {
            this.setRightTabCollapse(false);
        } else {
            this.setRightCollapse(true);
        }
    }

    public setRequestType(): void {
        if (this.mappingBoard && this.bot) {
            if (this.bot.botType === "internal") {
                this.requestType = "write";
            } else if (this.mappingBoard.isQueryWriteService && this.mappingBoard.boardIndex === 0) {
                this.requestType = "query";
            } else if (this.mappingBoard.isLtr && this.bot.category !== "create" && this.mappingBoard.boardIndex === 0) {
                this.requestType = "query";
            } else if (!this.mappingBoard.isLtr && this.bot.category === "exist") {
                this.requestType = "answer";
            } else if (!this.mappingBoard.isLtr && this.bot.category === "listener") {
                this.requestType = "listen";
            } else if ((this.mappingBoard.isLtr && this.bot.category === "create") || (!this.mappingBoard.isLtr && this.bot.botType === "document") || (this.mappingBoard.boardIndex > 0 && this.mappingBoard.isLtr)) {
                this.requestType = "write";
            } else if (!this.mappingBoard.isLtr && (this.bot.category === "create" || this.bot.category === "update" || this.bot.category === "other" || this.bot.botType === "document" || this.bot.category === "read" || this.bot.category === "log" || this.bot.category === "list" || this.bot.category === "upload" || this.bot.category === "display" || this.bot.category === "document_display" || this.bot.category === "document_generate" || this.bot.category === "document_upload" || this.bot.category === "document_generate_and_display" || this.bot.category === "document_generate_and_upload" || this.bot.category === "document_generate_upload_display" || this.bot.category === "document_upload_to_ds")) {
                this.requestType = "receive";
            }
        }
    }

    public dropped(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            // notify parent
            this.itemDrop.emit();
        }
    }

    public setRightFieldsVisibility(status): void {
        this.mappingBoard.onlyVisibleRightField = status;
        // need for DOM update
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }

    }

    public setLeftFieldsVisibility(status): void {
        this.mappingBoard.onlyVisibleLeftField = status;
        // need for DOM update
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    private setRightSideCollapse(array, status): void {
        array.forEach((input) => {
            if (input.isgroup) {
                input.isopen = !status;
            }
            if (Array.isArray(input.items)) { this.setRightSideCollapse(input.items, status); }
        });
    }

    public setLeftTabCollapse(status): void {
        this.mappingBoard.collapseFieldsLeft = status;
        this.allFieldGroups.forEach((g) => {
            g.opened = true;
            if (g.hasOwnProperty("items")) {
                this.setChildrensTabCollapsed(status, g.items);
            }
        });
        // very important!!
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public setRightTabCollapse(status): void {
        this.mappingBoard.collapseFieldsRight = status;
        this.fields.forEach((g) => {
            g.isopen = true;
            if (g.hasOwnProperty("items")) {
                this.setChildrensTabCollapsed(status, g.items);
            }
        });
        // very important!!
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public setChildrensTabCollapsed(status, items): void {
        if (items) {
            items.forEach((item) => {
                item.opened = false;
                item.isopen = false;
                if (item.hasOwnProperty("items")) {
                    this.setChildrensCollapsed(false, item.items);
                }
            });
        }
    }

    public setLeftCollapse(status): void {
        this.mappingBoard.collapseFieldsLeft = status;
        if (this.selectedLeftTab !== null && status === true) {
            this.setLeftTabCollapse(status);
        } else {
            this.setChildrensCollapsed(status, this.allFieldGroups);
        }
        // very important!!
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public setRightCollapse(status): void {
        this.mappingBoard.collapseFieldsRight = status;
        // this.setRightSideCollapse(this.fields, status);
        if (this.selectedRightTab !== null && status === true) {
            this.setRightTabCollapse(status);
        } else {
            this.setChildrensCollapsed(status, this.fields);
        }
        // very important!!
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public searchInItems(items, searchedString) {
        return items && items.some((i) => {
            const group = i.isgroup ? this.searchInItems(i.items, searchedString) : false;
            const name = i.name ? i.name.toLowerCase().includes(searchedString) : false;
            const outputName = i.outputName ? i.outputName.toLowerCase().includes(searchedString) : false;
            if (group) {
                i.items = this.filterItems(i.items, searchedString);
            }
            return (group + name + outputName);
        });
    }

    public filterItems(items, searchedString) {
        return items.filter((it) => {
            const group = it.isgroup ? this.searchInItems(it.items, searchedString) : false;
            const name = it.name ? it.name.toLowerCase().includes(searchedString) : false;
            const outputName = it.outputName ? it.outputName.toLowerCase().includes(searchedString) : false;
            if (group) {
                it.items = this.filterItems(it.items, searchedString);
            }
            return (group + name + outputName);
        });
    }

    public searchLeftChanged(value: any): void {
        // filter inputs
        this.mappingBoard.leftFilter = value;

        const searchStringFormatted = value.toLowerCase();

        if (value && value.length) {
            this.filteredFieldGroups = this.filterItems(cloneDeep(this.allFieldGroups), searchStringFormatted);
        } else {
            this.filteredFieldGroups = this.allFieldGroups;
        }
        // need for DOM update
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public searchInternalRightChanged(value: any): void {
        // filter inputs
        this.mappingBoard.rightFilter = null;

        const searchStringFormatted = value.toLowerCase();
        const rightGroups = this.bot.botType === "internal" ? this.internalAllFieldGroups : this.allFieldGroups;
        if (value && value.length) {
            this.fields = this.filterItems(cloneDeep(rightGroups), searchStringFormatted);
        } else {
            this.fields = cloneDeep(rightGroups);
        }
        // need for DOM update
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public searchRightChanged(value: any): void {
        // filter inputs
        this.mappingBoard.rightFilter = { filter: value };
        // need for DOM update
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public setChildrensCollapsed(status, items): void {
        if (items) {
            items.forEach((item) => {
                if (item.type !== "catalog" && item.type !== "select" && item.type !== "editgrid" && item.type !== "datagrid" && item.type !== "select_folder") {
                    item.opened = !status;
                    item.isopen = !status;
                    if (item.hasOwnProperty("items")) {
                        this.setChildrensCollapsed(status, item.items);
                    }
                }
            });
        }
    }

    public isAvailable(bot: Bot): boolean {
        if (this.mappingBoard.type === "input") { return true; }
        switch (bot.category) {
            case "exist":
            case "read":
            case "display":
            case "document_upload_to_ds":
            case "document_display":
            case "document_generate":
            case "document_upload":
            case "document_generate_and_display":
            case "document_generate_and_upload":
            case "document_generate_upload_display":
            case "update":
            case "create":
            case "list":
            case "listener":
            case "search":
            case "other":
            case "upload":
            case "log":
                return true;
            default:
                return false;
        }
    }

    public onAddDataTransformation(fieldItem): void {
        this.addDataTransformation.emit({item: fieldItem, boardType: this.requestType, isLtr: this.mappingBoard.isLtr});
    }

    public scroll() {
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
        this.updateLinesVisibility.emit(this.mappingBoard.id);
    }

    public checkVersion() {
      const serviceNamePrefix = Helpers.getBotServiceNamePrefix(this.bot.botServiceId);
      const serviceVersion = Helpers.getBotServiceVersion(this.bot.botServiceId);
      const serviceNameSuffix = Helpers.getBotServiceNameSuffix(this.bot.botServiceId);
      for (const muleService of this.muleServices) {
        if (Helpers.getBotServiceNamePrefix(muleService.id) === serviceNamePrefix && Helpers.getBotServiceNameSuffix(muleService.id) === serviceNameSuffix) {
          const version = Helpers.getBotServiceVersion(muleService.id);
          if (version > serviceVersion) {
            this.isLastServiceVersion = false;
            return;
          }
        }
      }
      this.isLastServiceVersion = true;
    }

    public deleteGhostMapping(e) {
        if (e.ghosts.length) {
            const promises = [];
            if (e.board.isLtr) {
                e.ghosts.forEach((g) => {
                    promises.push(
                        this.botController.deleteBotInputMapping(g.lineId).pipe(map((data) => {
                            return data;
                        })).toPromise(),
                    );
                });
            } else {
                e.ghosts.forEach((g) => {
                    promises.push(
                        this.botController.deleteBotOutputMapping(g.lineId).pipe(map((data) => {
                            return data;
                        })).toPromise(),
                    );
                });
            }
            Promise.all<any[]>(promises).then((results: any[]) => {
                this.responseSuccessful("Ghosts deleted!");
                e.ghosts.forEach((g) => {
                  this.checkQueryFilterAfterDelete(g.lineId, false);
                });

            });
        }
    }

    public deleteLTRline(id: any) {
        this.botController.deleteBotInputMapping(id).subscribe((d) => {
            this.checkQueryFilterAfterDelete(id);
        });
    }

    public deleteRTLline(id: any) {
        this.botController.deleteBotOutputMapping(id).subscribe((d) => {
            console.log(d);
        });
    }

    public checkQueryFilterAfterDelete(id: any, emit: boolean = true) {
        if (this.bot.inputQueryFilter) {
            let groups: any[] = [];
            if (this.bot.inputQueryFilter instanceof Array || typeof this.bot.inputQueryFilter === "object") {
                groups = this.bot.inputQueryFilter;
            } else {
                groups = JSON.parse(this.bot.inputQueryFilter);
            }
            if (groups.length) {
                groups.forEach((g, index) => {
                    g.items = g.items.filter((i) => i.lineId !== id );
                    if (g.items.length < 1) {
                        groups.splice(index, 1);
                    }
                });
            }
            this.saveQueryEvent.emit({filters: groups.length > 0 ? groups : null, showLines: emit });
        }
    }

    public addRelationship(args) {
        console.log(args);
        const options = Object(args);
        if (options.map && options.map.fieldKey) {
            const dataMapping = new DataMapping();
            dataMapping.sourceField = options.map.fieldKey;
            dataMapping.sourceType = options.map.fieldType;
            dataMapping.targetField = options.map.inputId;
            dataMapping.targetType = options.map.targetType;
            if (options.isLtr) {
                this.botController.createBotInputMapping(this.bot.id, dataMapping).subscribe((d) => {
                    const savedMapping = JSON.parse(d);
                    dataMapping.id = savedMapping.id;
                    this.checkQueryFilterAfterAdd(savedMapping.id);
                    this.bot.inputFieldsMapping.push(dataMapping);
                    if (options.line) {
                        options.line.lineId = savedMapping.id;
                        this.mappingBoard.addRelationship(options.line);
                        this.handleScroll.emit();
                    }
                });
            } else {
                this.botController.createBotOutputMapping(this.bot.id, dataMapping).subscribe((d) => {
                    const savedMapping = JSON.parse(d);
                    dataMapping.id = savedMapping.id;
                    this.bot.outputFieldsMapping.push(dataMapping);
                    if (options.line) {
                        options.line.lineId = savedMapping.id;
                        this.mappingBoard.addRelationship(options.line);
                        this.handleScroll.emit();
                    }
                });
            }
        }
    }

    public checkQueryFilterAfterAdd(id) {
        if (this.bot.inputQueryFilter) {
            let groups: any[] = [];
            if (this.bot.inputQueryFilter instanceof Array || typeof this.bot.inputQueryFilter === "object") {
                groups = this.bot.inputQueryFilter;
            } else {
                groups = JSON.parse(this.bot.inputQueryFilter);
            }
            if (groups.length) {
                groups[0].items.push({ type: LogicGroupType.AND, lineId: id });
                this.saveQueryEvent.emit({filters: groups, showLines: true  });
            }
        }
    }

    public askForShowingLines(e) {
        this.showLines.emit(e);
    }

    public askForHidingLines(e) {
        this.hideLines.emit(e);
    }

    public saveQuery(e) {
        this.isOTMClosed = true;
        e.showLines = true;
        this.saveQueryEvent.emit(e);
    }
}
